module.exports = __webpack_public_path__ + "img/alert4.6b873a51.png";